import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type AlertTrendRegisterDataDeviceDashboard } from '../services/getAlertTredRegisterData'

export interface AlertTrendRegisterDataDeviceState {
  isLoading: boolean
  errorMessage: string | null
  AlertTrendRegisterDataDeviceDashboard: AlertTrendRegisterDataDeviceDashboard | null
  httpStatus: number | null
}

// Initial state of the slice

const initialState: AlertTrendRegisterDataDeviceState = {
  AlertTrendRegisterDataDeviceDashboard: null,
  isLoading: false,
  errorMessage: null,
  httpStatus: null
}

// Slice to return from action
export const AlertTrendRigisterDeviceDataState = createSlice({
  name: 'AlertTrendKPIDataAssetGraphData',
  initialState,
  reducers: {
    AlertTrendRegisterDataDeviceLoadingAction: (state) => {
      // clear out the data whenever we reload
      return {
        AlertTrendRegisterDataDeviceDashboard: null,
        isLoading: true,
        errorMessage: null,
        httpStatus: 0
      }
    },
    AlertTrendRegisterDataDeviceUpdateAction: (state, action: PayloadAction<any>) => {
      return {
        AlertTrendRegisterDataDeviceDashboard: action.payload.data,
        isLoading: false,
        errorMessage: null,
        httpStatus: action.payload.httpStatus
      }
    },
    AlertTrendRegisterDataDeviceErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        AlertTrendRegisterDataDeviceDashboard: null,
        isLoading: false,
        errorMessage: action.payload.errorMessage,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

// Actions to export
export const {
  AlertTrendRegisterDataDeviceLoadingAction,
  AlertTrendRegisterDataDeviceUpdateAction,
  AlertTrendRegisterDataDeviceErrorAction
} = AlertTrendRigisterDeviceDataState.actions

export default AlertTrendRigisterDeviceDataState.reducer
